import {
  SubmissionTypeContainer,
  SubmissionTypeSelectableContent,
  SubmissionTypeSpacing,
  SubmissionTypeTick,
} from './RelationshipType.styles';
interface RelationshipTypeProps {
  name: string;
  active: boolean;
  onClick(): void;
  index?: number;
}

export const RelationshipType = (props: RelationshipTypeProps) => (
  <SubmissionTypeContainer active={props.active}>
    <SubmissionTypeSpacing>
      <SubmissionTypeSelectableContent onClick={props.onClick}>
        <SubmissionTypeTick
          data-testid={`relationship-type-tick-${props.index}`}
          src={
            props.active ? '/assets/tick-full.png' : '/assets/tick-empty.png'
          }
        />
        <p>{props.name}</p>
      </SubmissionTypeSelectableContent>
    </SubmissionTypeSpacing>
  </SubmissionTypeContainer>
);
